import React, { useState, useEffect } from 'react'

import { Button, Card, Table, Typography, Icon, Input } from 'antd'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import { TableLineDisable } from '../../components/TableLineDisable/TableLineDisable'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

const ListOrganizationTypes = function ({ match, history }) {
  // Settings form
  const [formatedData, setFormatedData] = useState([])
  const [formValues, setFormValues] = useState({})
  const { count, page, pageSize } = formatedData
  // Created component
  useEffect(() => {
    listOrganizationTypes(formValues)

    return () => {
      setFormValues({})
      setFormatedData({})
    }
  }, [])

  // Api requests
  async function listOrganizationTypes(params) {
    try {
      const response = await request(api.listOrganizationTypes(params))
      console.tron.log('response listOrganizationTypes', response)
      const itens = response.items
      const formatedRows = []
      itens.map((item) => {
        return formatedRows.push({
          key: item.id,
          ...item,
          actions: formatActionsContent(item.id)
        })
      })
      setFormatedData({
        ...response,
        items: formatedRows,
        actions: 'teste'
      })
    } catch (error) {
      console.tron.log(error)
    }
  }

  function sortText(a, b, field) {
    if (a !== null && a[field] !== null && b !== null && b[field] !== null && field !== null) {
      if (a[field] < b[field]) return -1
      if (a[field] > b[field]) return 1
    }

    return 0
  }

  // Formaters
  const columns = [
    {
      title: getMessage('description'),
      dataIndex: 'typeName',
      sorter: (a, b) => sortText(a, b, 'typeName'),
      width: '90%',
      render: (item, line) => <TableLineDisable item={item} line={line} />
    }
  ]

  function onChange(pagination) {
    const { current } = pagination
    listOrganizationTypes({
      page: current - 1,
      ...formValues
    })
  }

  const formatActionsContent = (id) => (
    <Button
      className="default-actionContent-button"
      type="link"
      onClick={() => {
        history.push(`/organizationTypes/${id}`)
      }}
    >
      <Icon type="edit" className="default-actionContent-icon" />
    </Button>
  )

  function renderHeader() {
    return (
      <div className="default-header-div">
        <Typography.Title className="default-header-title" level={3}>
          {getMessage('listOrganizationTypes')}
        </Typography.Title>
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
          <Button
            className="default-header-button"
            type="primary"
            onClick={() => history.push('/organizationTypes/create')}
            style={{ visibility: 'hidden' }}
          >
            {getMessage('storeOrganizationTypes')}
          </Button>
        </div>
      </div>
    )
  }

  return (
    <>
      {renderHeader()}

      <Card className="ant-card gx-card ant-card-bordered">
        <Input.Search
          className="default-header-search"
          onSearch={(value) => listOrganizationTypes({ search: value })}
          placeholder={getMessage('search')}
        />
        <Table
          key="id"
          columns={columns}
          dataSource={formatedData.items}
          onChange={onChange}
          pagination={{ pageSize, current: page + 1, total: count }}
        />
      </Card>
    </>
  )
}

export default ListOrganizationTypes
